import React from 'react';
import { CTAButton } from './CTAButton';
const TOMOS = [{
  icon: '📘',
  title: 'TOMO 1 — Fundamentos CALMA',
  desc: 'Entendé cómo funciona tu sistema nervioso cuando explotás y aprendé a frenarlo antes de que sea tarde. La base de todo el método.',
  price: '$15.000'
}, {
  icon: '📗',
  title: 'TOMO 2 — El Tablero de Rutinas Mágicas',
  desc: 'Mañanas y noches sin peleas en 7 días. Un sistema visual que los chicos entienden y siguen solos.',
  price: '$15.000'
}, {
  icon: '📙',
  title: 'TOMO 3 — Rabietas con Calma',
  desc: 'El protocolo paso a paso para los momentos de mayor intensidad emocional. Qué hacer, qué decir y qué NO hacer cuando todo explota.',
  price: '$15.000'
}, {
  icon: '📕',
  title: 'TOMO 4 — El Diccionario de las Emociones',
  desc: 'Cuando tu hijo aprende a decir lo que siente, todo cambia. Guía práctica para ampliar el vocabulario emocional de toda la familia.',
  price: '$15.000'
}, {
  icon: '📒',
  title: 'TOMO 5 — Disciplina Sin Gritos',
  desc: 'Autoridad firme, corazón suave. Cómo poner límites reales sin culpa, sin guerra y sin negociar eternamente.',
  price: '$15.000'
}, {
  icon: '📓',
  title: 'TOMO 6 — El Diario de la Madre Calmada',
  desc: 'Rutinas cortas para recuperar paciencia, energía y paz. Para vos. Porque una mamá que se cuida, cuida mejor.',
  price: '$15.000'
}];
export function TomosSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 bg-gray-50" data-id="element-246">
      <div className="max-w-5xl mx-auto" data-id="element-247">
        <div className="text-center mb-16" data-id="element-248">
          <h2 className="inline-block text-3xl md:text-5xl font-black text-gray-900 bg-yellow-300 px-6 py-2 transform -rotate-1 shadow-md" data-id="element-249">
            ✅ ESTO ES TODO LO QUE RECIBÍS HOY
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-16" data-id="element-250">
          {TOMOS.map((tomo, idx) => <div key={idx} className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow relative overflow-hidden group" data-id="element-251">
              {/* Decorative background number */}
              <div className="absolute -right-4 -top-8 text-9xl font-black text-gray-50 opacity-50 group-hover:scale-110 transition-transform duration-500 pointer-events-none" data-id="element-252">
                {idx + 1}
              </div>

              <div className="relative z-10" data-id="element-253">
                <div className="text-5xl mb-4" data-id="element-254">{tomo.icon}</div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 pr-8" data-id="element-255">
                  {tomo.title}
                </h3>
                <p className="text-gray-600 text-lg leading-relaxed mb-6 min-h-[80px]" data-id="element-256">
                  {tomo.desc}
                </p>
                <div className="flex items-center gap-2 text-sm font-bold text-gray-400 bg-gray-50 inline-flex px-3 py-1 rounded-md border border-gray-100" data-id="element-257">
                  Valor real: <span className="line-through" data-id="element-258">{tomo.price}</span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-259">
          <p className="text-xl font-bold text-gray-800 mb-6" data-id="element-260">
            Las rabietas no esperan. Estas herramientas sí las podés tener hoy.
          </p>
          <CTAButton text="👉 Un solo pack. Todas las herramientas que necesitás." onClick={scrollToPricing} data-id="element-261" />
        </div>
      </div>
    </section>;
}